<template>
  <div class="settings">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/buergerkonto">Bürgerkonto</router-link>
      <router-link to="/buergerkonto/einstellungen">Profil & Einstellungen</router-link>
    </Breadcrumb>
    <div class="settings__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/buergerkonto" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="settings" color="detailed" class="hide-mobile"/>
          <Headline subline="Bürgerkonto" headline="Profil & Einstellungen" />
        </div>
        <div class="headline-link__right hide-mobile">
          <form @submit.prevent="" class="input-wrapper">
            <input type="search" placeholder="Einstellung suchen...">
            <Icon icon="search"/>
          </form>
        </div>
      </div>
    </div>
    <div class="settings__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs">
        <div class="settings__content__left col-xs-12 col-md-8">

          <!-- Profil -->
          <div class="settings-tab" v-show="activeTab == 1">
            <div class="settings-tab__header">
              <h6>Profil</h6>
              <div class="text">
                <p>Alle Daten für Autofill freigeben</p>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">Hallo</div>
                </div>
                <div></div>
                <Toggle @click.native="toggleAllToggles"/>
              </div>
            </div>
            <div class="settings-tab__content">
              <!-- First Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Angaben zur Person</h6>
                  <div>
                    <span>Freigeben</span>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
                <div class="column__content">
                  <table>
                    <tr>
                      <td>Name:</td>
                      <td>{{ activeUser.firstName }} {{ activeUser.lastName }}</td>
                    </tr>
                    <tr>
                      <td>Geburtsdatum:</td>
                      <td>12.09.1992</td>
                    </tr>
                    <tr>
                      <td>Geburtsort:</td>
                      <td>Ravensburg</td>
                    </tr>
                    <tr>
                      <td>Anschrift:</td>
                      <td>Maximilianstraße 23
                        <br>86150 Augsburg
                      </td>
                    </tr>
                    <tr>
                      <td>Staatsangehörigkeit:</td>
                      <td>Deutsch</td>
                    </tr>
                    <tr>
                      <td>Registriert seit:</td>
                      <td>17.05.2018</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- Second Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Ausweis-Daten</h6>
                  <div>
                    <span>Freigeben</span>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
                <div class="column__content">
                  <table>
                    <tr>
                      <td>Ausweis-Nr:</td>
                      <td>{{ activeUser.idNumber }}</td>
                    </tr>
                    <tr>
                      <td>Ausgestellt am:</td>
                      <td>13.05.2016</td>
                    </tr>
                    <tr>
                      <td>Gültig bis:</td>
                      <td>12.05.2021</td>
                    </tr>
                    <tr>
                      <td>E-Signatur:</td>
                      <td>Eingerichtet, aktiviert</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- Third Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Persönliche-Angaben</h6>
                  <div>
                    <span>Freigeben</span>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
                <div class="column__content">
                  <Icon icon="edit" class="edit" @click.native="toggleEditModal" title="Angaben bearbeiten"/>
                  <table>
                    <tr>
                      <td>Familienstand:</td>
                      <td>Ledig</td>
                    </tr>
                    <tr>
                      <td>Steueridentifikationsnummer:</td>
                      <td>1127748294039</td>
                    </tr>
                    <tr>
                      <td>Sozialversicherungsnummer:</td>
                      <td>TS27384950</td>
                    </tr>
                    <tr>
                      <td>Krankenkasse:</td>
                      <td>Siemens Betriebskrankenkasse (SBK)</td>
                    </tr>
                    <tr>
                      <td>Versichertennummer:</td>
                      <td>E200400600</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- Fourth Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Kontakt</h6>
                  <div>
                    <span>Freigeben</span>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
                <div class="column__content">
                  <Icon icon="edit" class="edit" @click.native="toggleEditModal" title="Angaben bearbeiten"/>
                  <table>
                    <tr>
                      <td>E-Mail:</td>
                      <td>{{activeUser.firstName.toLowerCase()}}.{{activeUser.lastName.toLowerCase()}}@gmx.de</td>
                    </tr>
                    <tr>
                      <td>Telefon:</td>
                      <td>+49 157 9900223</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- Fifth Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Bankverbindung</h6>
                  <div>
                    <span>Freigeben</span>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
                <div class="column__content">
                  <Icon icon="edit" class="edit" @click.native="toggleEditModal" title="Angaben bearbeiten"/>
                  <table>
                    <tr>
                      <td>Geldinstitut:</td>
                      <td>Ledig</td>
                    </tr>
                    <tr>
                      <td>IBAN:</td>
                      <td>DE29600500400300</td>
                    </tr>
                    <tr>
                      <td>BIC:</td>
                      <td>GENODES1AU</td>
                    </tr>
                  </table>
                </div>
              </div>
              <!-- Sixth Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Arbeitgeber</h6>
                  <div>
                    <span>Freigeben</span>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
                <div class="column__content">
                  <Icon icon="edit" class="edit" @click.native="toggleEditModal" title="Angaben bearbeiten"/>
                  <table>
                    <tr>
                      <td>Arbeitgeber:</td>
                      <td>Lech Energie GmbH & Co. KG</td>
                    </tr>
                    <tr>
                      <td>Anschrift:</td>
                      <td>Bertholdstraße 26A <br>86159 AUgsburg</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
          </div>

<!-- +++++ Einstellungen 1 +++++++ -->
          <div class="settings-tab" v-show="activeTab == 2">
            <div class="settings-tab__header">
              <h6>Sicherheit & Login</h6>
              <div class="text">
                <p>Alle</p>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">Hallo</div>
                </div>
                <div></div>
                <Toggle @click.native="toggleAllToggles"/>
              </div>
            </div>
            <div class="settings-tab__content">
              <!-- First Column -->
              <div class="column">
                <div class="column__content">
                  <div class="setting">
                    <div class="with-icon">
                      <Icon icon="lock"/>
                      <p>Passwort ändern</p>
                    </div>
                    <span @click="toggleEditModal">Bearbeiten</span>
                  </div>
                  <div class="setting">
                    <p>Automatischer Logout nach Inaktivität (10 Minuten)</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
              </div>
              <!-- Second Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Ihre authentifizierten Geräte</h6>
                  <div class="hint">
                    <Icon icon="hint" />
                    <div class="hint__tooltip">Hallo</div>
                  </div>
                </div>
                <div class="column__content">
                  <div class="setting">
                    <div class="with-icon">
                      <Icon icon="computer" color="detailed" class="big" />
                      <div class="two-rows">
                        <p>Apple MacBook Pro</p>
                        <p>Letzter Login: 26.01.2019</p>
                      </div>
                    </div>
                    <span @click="toggleEditModal">Entfernen</span>
                  </div>
                  <div class="setting">
                    <div class="with-icon">
                      <Icon icon="phone" color="detailed" class="big" />
                      <div class="two-rows">
                        <p>Samsung Galaxy S9</p>
                        <p>Letzter Login: 06.02.2019</p>
                      </div>
                    </div>
                    <span @click="toggleEditModal">Entfernen</span>
                  </div>
                  <div class="setting margin-top--10">
                    <p>Anmeldungswarnung erhalten bei Login über unbekanntes Gerät?</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

<!-- +++++ Einstellungen 2 +++++++ -->
          <div class="settings-tab" v-show="activeTab == 3">
            <div class="settings-tab__header">
              <h6>Dokumentenbox & Daten</h6>
              <div class="text">
                <p>Alle</p>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">Hallo</div>
                </div>
                <div></div>
                <Toggle @click.native="toggleAllToggles"/>
              </div>
            </div>
            <div class="settings-tab__content">
              <!-- First Column -->
              <div class="column">
                <div class="column__content">
                  <div class="setting">
                    <p>Eingehende Dokumente in Dokumentenbox ablegen?</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                  <div class="setting">
                    <p>Von Gerät hochgeladene Dokumente immer automatisch in Dokumentenbox ablegen</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <p>Ausgehende Anträge auch für Bundes- & Ländesbehörden freigeben?</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                  <div class="setting">
                    <p>Ausgefüllte Eingabefelder für spätere Anträge merken (Profil)</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                  <div class="setting">
                    <p>Nachweise,Urkunden & Zertifikate zusätzlich postalisch zusenden (0,80€)</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                  <div class="setting">
                    <p>Bürgerkonto-Daten nutzen um persönlich passende Dienstleistungen anzuzeigen</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                </div>
              </div>
              <!-- Second Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Dokumentenzugriff</h6>
                  <div class="hint">
                    <Icon icon="hint" />
                    <div class="hint__tooltip">Hallo</div>
                  </div>
                </div>
                <div class="column__content">
                  <div class="setting margin-bottom--10">
                    <p>Dokumente & Daten für Behördenugriffe freigeben?</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <h6>Kein Zugriff für...</h6>
                    <span @click="toggleEditModal">+ Hinzufügen</span>
                  </div>
                  <div class="setting">
                    <div class="with-icon">
                      <Icon icon="school" color="detailed" class="big" />
                      <div class="two-rows">
                        <p>Finanzamt Augsburg</p>
                        <p>Auf der Liste seit: 26.01.2019</p>
                      </div>
                    </div>
                    <span @click="toggleEditModal">Entfernen</span>
                  </div>
                  <div class="setting">
                    <div class="with-icon">
                      <Icon icon="office" color="detailed" class="big" />
                      <div class="two-rows">
                        <p>Agentur für Arbeit Augsburg</p>
                        <p>Auf der Liste seit: 12.01.2019</p>
                      </div>
                    </div>
                    <span @click="toggleEditModal">Entfernen</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

<!-- +++++ Einstellungen 3 +++++++ -->
          <div class="settings-tab" v-show="activeTab == 4">
            <div class="settings-tab__header">
              <h6>Benachrichtigungen</h6>
              <div class="text">
                <p>Alle</p>
                <div class="hint">
                  <Icon icon="hint" />
                  <div class="hint__tooltip">Hallo</div>
                </div>
                <div></div>
                <Toggle @click.native="toggleAllToggles"/>
              </div>
            </div>
            <div class="settings-tab__content">
              <!-- First Column -->
              <div class="column">
                <div class="column__content">
                  <div class="setting">
                    <p>Benachrichtigungen auch an E-Mail-Adresse senden</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                  <div class="setting">
                    <p>Benachrichtigungen auch per SMS erhalten</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <p>Push-Benachrichtigungen erlauben</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                </div>
              </div>
              <!-- Second Column -->
              <div class="column">
                <div class="column__header">
                  <h6>Mitteilung erhalten bei..</h6>
                  <div class="hint">
                    <Icon icon="hint" />
                    <div class="hint__tooltip">Hallo</div>
                  </div>
                </div>
                <div class="column__content">
                  <div class="setting">
                    <p>Änderung des Statuses Ihrer Behördenanfrage</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <p>Neue verfügbare Online-Services</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <p>Neues Dokument in Dokumentenbox</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <p>Meldungen die Ihren Wohnort betreffen (z.B. Verkehrseinschränkungen etc.)</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                  <div class="setting">
                    <p>Amtliche Mitteilungen der Stadt</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <p>Zugriff auf Ihre Dokumente durch eine Behörde</p>
                    <Toggle :toggled="toggleAll || true"/>
                  </div>
                  <div class="setting">
                    <p>Information zu bald ablaufenden Dokumenten (z.B. Reisepass)</p>
                    <Toggle :toggled="toggleAll"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        
        <Modal v-if="toggleEdit" @closeModal="toggleEditModal" :outside="true">
          <Card padding="35px" class="modal-new">
            <Headline subline="Datenfeld bearbeiten" headline="Leider nicht möglich"/>
            <p>Ätsch! Diese Funktion steht in diesem Prototyp leider nicht zur Verfügung.</p>
          </Card>           
        </Modal>

        <!-- Sidebar -->
        <div class="settings__content__sidebar col-xs-12 col-md-3">
          <div class="margin-bottom--30">
            <!-- 1 -->
            <div class="nav-element"
              @click="activeTab = 1" 
              :class="{'selected' : activeTab == 1}"
              >
              <Icon icon="user" />
              <div class="text">
                <h6>Profil</h6>
                <p>Angaben zu Ihrer Person</p>
              </div>
            </div>
            <!-- 2 -->
            <div class="nav-element"
              @click="activeTab = 2" 
              :class="{'selected' : activeTab == 2}"
              >
              <Icon icon="filter" />
              <div class="text">
                <h6>Sicherheit & Login</h6>
                <p>10 Einstellungen</p>
              </div>
            </div>
            <!-- 3 -->
            <div class="nav-element"
              @click="activeTab = 3" 
              :class="{'selected' : activeTab == 3}"
              >
              <Icon icon="filter" />
              <div class="text">
                <h6>Dokumentenbox & Daten</h6>
                <p>10 Einstellungen</p>
              </div>
            </div>
            <!-- 4 -->
            <div class="nav-element"
              @click="activeTab = 4" 
              :class="{'selected' : activeTab == 4}"
              >
              <Icon icon="filter" />
              <div class="text">
                <h6>Benachrichtigungen</h6>
                <p>20 Einstellungen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Teaser illu="settings" columns="5" subline="Ihr Bürgerkonto-Profil" headline="Sie bestimmen über Ihre Daten!">
      <p>In Ihrem persönlichen Profil sehen Sie alle Angaben die durch Ihren Ausweis bekannt sind. Zusätzlich können Sie weitere Angaben zu Ihrer Person machen, dass Ihnen das Ausfüllen von Online-Anträgen und Formularen erheblich erleichtert und beschleunigt. Diese Daten werden nur dann für die Formular-Autofill-Funktion freigegeben, wenn Sie dies explizit erlauben!
        <br>Unabhängig davon ist die Einsicht Ihrer Daten durch keine Behörde oder Einrichtung der öffentlichen Verwaltung möglich. Ihre Daten sind und bleiben hier also nur Ihnen zugänglich!</p>
    </Teaser>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';


export default {
  name: 'Settings',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
  },
  data() {
    return {
      showModal: false,
      toggleEdit: false,
      activeTab: 1,
      toggleAll: false,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
    }),
  },
  methods: {
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleEditModal() {
      this.toggleEdit = !this.toggleEdit;
    },
    toggleAllToggles() {
      this.toggleAll = true;
    },
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Settings.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Settings/Settings.vue